import { thmSslBaseUrl, thmOrgId } from 'server-data/flconfigs';
import { oneLineTrim } from 'common-tags';
import { getQueryStringValueByName } from '@shared/url';

export let tagsSessionId = localStorage.getItem('tags_session_id');

// Helper function to generate a session id
function getSessionId() {
  let sessionId = '';

  // 80 character long session id
  for (let i = 0; i < 20; i++) {
    sessionId += random4CharString();
  }

  return sessionId;
}

// Wrapped setItem() in a function due to empty block statement lint error
function setSessionIdToLocalStorage(tagsSessionId) {
  try {
    localStorage.setItem('tags_session_id', tagsSessionId);
  } catch (err) {
    // Safari private browsing mode fix
    return false;
  }
}

// Helper function to generate a string of 4 random characters
function random4CharString() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

// Do not initialise again if it has.
const existingElement = document.getElementById('external-threatmetrix');
// For flndev environments, disable Threatmetrix if the SSL base URL is false.
if (!existingElement && thmSslBaseUrl) {
  // Generate new sessionId if none is present in localStorage
  if (tagsSessionId === null) {
    tagsSessionId = getSessionId();
    setSessionIdToLocalStorage(tagsSessionId);
  }

  const arr = document.getElementsByName('thm_session');
  for (let i = 0; i < arr.length; i++) {
    arr[i].setAttribute('value', tagsSessionId);
  }

  // Inject script tag in document.
  const url = oneLineTrim`
    ${thmSslBaseUrl}/fp/tags.js?org_id=${thmOrgId}
    &session_id=${tagsSessionId}`;
  const po = document.createElement('script');
  po.id = 'external-threatmetrix';
  po.type = 'text/javascript';
  po.async = true;
  po.src = url;
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(po, s);

  // Set thm_session in cookie
  const date = new Date();
  // 1 year expiration time for cookie
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
  const expires = `path=/;expires=${date.toUTCString()}`;
  document.cookie = `session2=${tagsSessionId}; ${expires}`;

  if (
    window.location.search.indexOf(
      'token_2=0m1ylLupUYLx6wJbA4AtiBIsOhHvyGDr',
    ) !== -1
  ) {
    const referenceTwo = getQueryStringValueByName('reference_2');
    /**
     * The following section of code with it's magic "token=..." is to enable
     * the security team to track various actors without their knowledge.
     * See also: /users/validate.php
     */
    fetch(
      oneLineTrim`/users/validate.php?&t=15021959098890.6790854098336039
      &en=referrer&url=&q=&new_user=true&language=en&page=%2Flogin
      &token=login&location=http&edge=null&user_id=&
      session_id=83b1512e-0e44-666f-1ed2-8ce4882c3ed1&
      aqs=chrome..69i57j69i65l3j0l2.6351j0j7&sourceid=chrome&ie=UTF-8&reference=${referenceTwo ||
        'unknown'}`,
      {
        credentials: 'include',
      },
    );
  }
}
